import React, { useState, useEffect } from "react";
import AdminSidebar from "./AdminSidebar";
import AdminTopBar from "./AdminTopBar";
import { useNavigate } from "react-router-dom";
import api from "./api/axios";
import { getImageUrl } from "./utils/image";
import { useActivityLogger } from "./hooks/useActivity";
import { useSearch } from "./contexts/SearchContext";

export default function AdminCommunity() {
  const { searchQuery } = useSearch();
  const [communities, setCommunities] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;
  const navigate = useNavigate();
  const { logAdminActivity } = useActivityLogger();
  useEffect(() => {
    const fetchCommunities = async () => {
      try {
        const res = await api.get("/komunitas");
        setCommunities(res.data);
      } catch (err) {
        console.error("Failed to fetch communities", err);
      }
    };
    logAdminActivity(
      "view",
      "view_admin_community_list",
      "community",
      null,
      "admin",
      "success",
      "",
      "Admin viewed community list"
    );
    fetchCommunities();
  }, []);
  const filteredCommunities = communities.filter(community =>
    community.nama_komunitas?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    community.nomor_hp?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    community.website?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredCommunities.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredCommunities.length / itemsPerPage);

  const getSocialList = (data) => {
    const social = [];
    if (data.facebook) social.push("Facebook");
    if (data.instagram) social.push("Instagram");
    if (data.twitter) social.push("X");
    if (data.telegram) social.push("Telegram");
    if (data.tiktok) social.push("TikTok");
    if (data.whatsapp) social.push("WhatsApp");
    return social.join(", ");
  };

  const handleDelete = async (id, name) => {
    const confirmed = window.confirm(
      `Yakin ingin menghapus komunitas "${name}"?`
    );
    if (!confirmed) return;

    try {
      await api.delete(`/komunitas/${id}`);
      setCommunities((prev) => prev.filter((item) => item.ID !== id));
      logAdminActivity(
        "delete",
        "delete_community",
        "community",
        id,
        name,
        "success",
        "",
        `Community "${name}" deleted successfully`
      );
      window.alert("Komunitas berhasil dihapus.");
    } catch (err) {
      console.error("Gagal menghapus komunitas", err);
      window.alert("Terjadi kesalahan saat menghapus komunitas.");
    }
  };

  return (
    <div className="min-h-screen flex">
      <AdminSidebar />
      <div className="flex-1 p-6 bg-gray-50">
        <AdminTopBar />

        <div className="bg-white p-4 rounded shadow">
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-lg font-semibold">Komunitas Online</h2>
            <button
              onClick={() => navigate("/admin/community/add")}
              className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
            >
              + Tambah Komunitas
            </button>
          </div>

          <table className="w-full text-sm">
            <thead className="border-b">
              <tr>
                <th className="py-2 text-left">Foto</th>
                <th className="py-2 text-left">Nama Komunitas</th>
                <th className="py-2 text-left">No. HP</th>
                <th className="py-2 text-left">Website</th>
                <th className="py-2 text-left">Media Sosial</th>
                <th className="py-2"></th>
              </tr>
            </thead>
            <tbody>
              {currentItems.map((community) => (
                <tr key={community.ID} className="border-b">
                  <td className="py-2">
                    <img
                      src={getImageUrl(community.image_url) || "/avatar.png"}
                      alt={community.nama || "Komunitas"}
                      className="h-12 w-12 rounded object-cover"
                    />
                  </td>
                  <td className="py-2">{community.nama_komunitas || "-"}</td>
                  <td className="py-2">{community.nomor_hp || "-"}</td>
                  <td className="py-2">{community.website || "-"}</td>
                  <td className="py-2">{getSocialList(community)}</td>
                  <td className="py-2 align-middle">
                    <div className="flex items-center gap-2">
                      <button
                        onClick={() =>
                          navigate("/admin/community/update/" + community.ID)
                        }
                      >
                        <img
                          src="/icon-edit.png"
                          alt="Edit"
                          className="h-5 w-5"
                        />
                      </button>
                      <button
                        onClick={() =>
                          handleDelete(community.ID, community.nama_komunitas)
                        }
                      >
                        <img
                          src="/icon-trash.png"
                          alt="Delete"
                          className="h-5 w-5"
                        />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <div className="flex justify-end mt-4 gap-1">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              className="border px-2 py-1 rounded"
            >
              &lt;
            </button>
            {[...Array(totalPages)].map((_, i) => (
              <button
                key={i + 1}
                onClick={() => setCurrentPage(i + 1)}
                className={`border px-2 py-1 rounded ${currentPage === i + 1 ? "bg-blue-500 text-white" : ""}`}
              >
                {i + 1}
              </button>
            ))}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              className="border px-2 py-1 rounded"
            >
              &gt;
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
